import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ModalCadastroComponent } from '../../../shared/modal-cadastro/modal-cadastro.component';
import { MotivosMovimentacaoEstoqueService } from '../../../services/motivo-movimentacao-estoque.service';
import { setFieldFormValue, setFormValue } from '../../../general/utils';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-motivo-movimentacao-estoque',
  templateUrl: './motivo-movimentacao-estoque.component.html',
  styleUrls: ['./motivo-movimentacao-estoque.component.css']
})
export class MotivoMovimentacaoEstoqueComponent extends ModalCadastroComponent implements OnInit {

  @ViewChild("modalCadastro", { static: true }) modalCadastro;
  id;

  @Output() closed: EventEmitter<any> = new EventEmitter();

  constructor(private motivosMovimentacaoEstoqueService: MotivosMovimentacaoEstoqueService) {
    super();
  }

  cadastroForm = new FormGroup({
    id: new FormControl(0),
    nome: new FormControl(null, [Validators.required]),
    automatico: new FormControl(false, [Validators.required]),
  })

  ngOnInit() {
  }

  editar(id: number) {
    this.id = id;
    this.carregaDados();
    this.modalCadastro.show();
  }

  cadastrar(searchParam) {
    this.id = null;
    setFieldFormValue(this.cadastroForm, 'nome', searchParam);
    this.modalCadastro.show();
  }

  carregaDados() {
    if (this.id) {
      this.alteraLoading(true);
      this.motivosMovimentacaoEstoqueService.getById(this.id)
        .pipe(finalize(() => this.alteraLoading(false)))
        .subscribe((res) => {
          setFormValue(this.cadastroForm, res);
          this.id = res.id
        })
    }
  }

  submitForm() {
    if (this.cadastroForm.valid) {
      this.alteraLoading(true);
      this.motivosMovimentacaoEstoqueService.salvar(this.cadastroForm.value)
        .pipe(finalize(() => this.alteraLoading(false)))
        .subscribe(res => {
          this.id = res.generatedId || res.id;
          this.modalCadastro.hide();
        }, (error) => {
          this.errors = error.msg.errors[0];
        })
    }
  }
}
